import Vue from 'vue'

import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor);